import { toRaw } from 'vue'
import { GridTreeOption } from '../grid-tree-option'
import type { GridTreeOptions } from '../types'

function looksLikeGridTreeOption(value: unknown): value is GridTreeOption {
  if (value == null || typeof value !== 'object') {
    return false
  }
  const candidate = value as GridTreeOption
  return typeof candidate.module === 'string'
    && Array.isArray(candidate.columns)
    && candidate.columns.length > 0
}

export function isGridTreeOption(value: unknown): value is GridTreeOption {
  if (value == null) {
    return false
  }
  const raw = toRaw(value)
  const Ctor = globalThis.GridTreeOption
  if (Ctor && raw instanceof Ctor) {
    return true
  }
  return looksLikeGridTreeOption(raw)
}

export function resolveGridTreeOptions(
  options: GridTreeOption | GridTreeOptions
): GridTreeOptions {
  if (isGridTreeOption(options)) {
    return options
  }
  return options
}
